import { validateSomething } from "../../Form/Validations";

export class CIMIS {

    /**
   * @returns {import("../types").DialogState}
  */
    static actionDialogState(t, data, i18n,stations) {
        return {
            visible: true,
            activeStep: 0,
            data: {},
            nombre_servicio: data.nombre_servicio,
            resolveBody: (values, props) => {
                const body = {
                    ...values,
                    tipo: "CIMIS",
                    locale: i18n.language,
                    isEtoStation:stations.find(s =>s.StationNbr===values.StationNbr).IsEtoStation==="True"
                };
                return { url: `/external/${props.farmId}`, body };
            },
            steps: [
                {
                    label: t("sass.conectar"),
                    inputs: [
                        {
                            label: t("external.selectStation"),
                            campo: "StationNbr",
                            validation: validateSomething,
                            component: "select",
                            options: stations?.filter(s => s.IsActive==="True"),
                            optionLabel: "Name",
                            optionKey: "StationNbr",
                            onChange: (value, props) => {
                                props.setFieldValue("sectorName", `CIMIS - ${stations.find(s =>s.StationNbr===value).Name}`);
                            },
                            tooltip:t("marketplace.cimisTooltip")
                        },
                        {
                            label: t("external.sector-name"),
                            campo: "sectorName",
                            validation: validateSomething,
                            component: "text",
                        },
                    ],
                },
            ],
        };
    }
}
